import { render, staticRenderFns } from "./ArticleNameTrackingToggle.vue?vue&type=template&id=13bfe94d&scoped=true"
import script from "./ArticleNameTrackingToggle.vue?vue&type=script&lang=js"
export * from "./ArticleNameTrackingToggle.vue?vue&type=script&lang=js"
import style0 from "./ArticleNameTrackingToggle.vue?vue&type=style&index=0&id=13bfe94d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfe94d",
  null
  
)

export default component.exports